/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosEnumDirectoryVariant } from "@cosmos/hygraph-schema";

import type { TrainingPartnerCardVariant } from "./types";

/** URL param namespace per training-partner-shaped directory, so their filter keys never collide. */
export function trainingPartnerParamPrefix(variant: TrainingPartnerCardVariant): "ap" | "tp" {
	return variant === CosmosEnumDirectoryVariant.AcademicPartners ? "ap" : "tp";
}
